const ERROR_MAP: Record<number, { title: string; description: string }> = {
  404: {
    title: 'Page not found',
    description:
      "The page you're looking for does not exist. Perhaps you can return to our homepage to find what you need.",
  },
  410: {
    title: 'Content permanently removed',
    description:
      'This content has been permanently removed. Perhaps you can return to our homepage to find what you need.',
  },
  500: {
    title: 'Something went wrong',
    description:
      'There was a problem loading this page. Please try again later.',
  },
};

export function getErrorConfig(statusCode: number) {
  return ERROR_MAP[statusCode] ?? ERROR_MAP[404];
}

export default function ErrorContent({
  statusCode,
  children,
}: {
  statusCode: number;
  children?: React.ReactNode;
}) {
  const { title, description } = getErrorConfig(statusCode);

  return (
    <section className='min-h-[60vh] pt-20'>
      <h1 className='text-3xl font-bold'>{title}</h1>
      <p className='mt-4 text-lg text-gray-600'>{description}</p>
      {children}
    </section>
  );
}
